import { render, staticRenderFns } from "./SidebarDesktop.vue?vue&type=template&id=57c59cf6&scoped=true&"
import script from "./SidebarDesktop.vue?vue&type=script&lang=ts&"
export * from "./SidebarDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarDesktop.vue?vue&type=style&index=0&id=57c59cf6&lang=less&scoped=true&"
import style1 from "./SidebarDesktop.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c59cf6",
  null
  
)

export default component.exports